import React, { useMemo, useState } from 'react';

import ControlBarValueLabel from 'components/b2c/ControlBarValueLabel';
import { manualTimeUpdateEvent } from 'components/b2c/Mp3KbpPlayer/Mp3KbpPlayer.constants';
import { useMediaElementListener } from 'services/hooks/useMediaElementListener';

import { Slider, TimeSliderContainer, CustomSliderRail, BufferedTrack } from './TimeSlider.style';
import { getBufferedTimeRangesArray } from '../Mp3KbpPlayerControls/utils';

interface Props {
  songDuration: number;
  songFutureTime: number | null;
  setSongFutureTime: (futureTime: number | null) => void;
  bufferedTimeRanges: TimeRanges | null;
  videoElement: HTMLVideoElement;
}

const TimeSlider: React.FC<Props> = ({
  songDuration,
  songFutureTime,
  setSongFutureTime,
  bufferedTimeRanges,
  videoElement,
}) => {
  const [songCurrentTime, setSongCurrentTime] = useState<number>(0);

  useMediaElementListener(videoElement, 'timeupdate', () =>
    setSongCurrentTime(videoElement.currentTime),
  );

  const bufferedTimeRangesArray = useMemo(
    () => getBufferedTimeRangesArray(bufferedTimeRanges),
    [bufferedTimeRanges],
  );

  return (
    <TimeSliderContainer>
      <Slider
        max={songDuration}
        value={songFutureTime ?? songCurrentTime}
        components={{
          ValueLabel: ControlBarValueLabel,
        }}
        valueLabelDisplay='auto'
        onChange={(_, value) => {
          setSongFutureTime(value as number);
        }}
        onChangeCommitted={() => {
          videoElement.dispatchEvent(manualTimeUpdateEvent);
          if (songFutureTime !== null) {
            setSongCurrentTime(songFutureTime);
          }
          setSongFutureTime(null);
        }}
      />
      <CustomSliderRail />
      {songDuration > 0 &&
        bufferedTimeRangesArray.map(({ start, end }) => (
          <BufferedTrack
            key={`${start}-${end}`}
            start={start}
            end={end}
            songDuration={songDuration}
          />
        ))}
    </TimeSliderContainer>
  );
};

export default TimeSlider;
